export default {
  login: {
    label: {
      username: 'Username',
      password: 'Password',
      forgottenPassword: 'Forgotten Password?',
      loading: 'Loading...',
    },
    validation: {
      username: {
        required: 'Username is required',
      },
      password: {
        required: 'Password is required',
      },
    },
    notACustomer: 'Not a Whizeo customer yet?',
    getInTouch: 'Get in touch to arrange a demo and learn more about working with Whizeo',
    loginForm: 'Login',
    loginButton: 'Log In',
    learnMore: 'Learn More',
  },
  forgottenPassword: {
    submit: 'Submit',
    returnToLogin: 'Return to Login',
    validation: {
      username: {
        required: 'Username is required',
      },
    },
    confirmation: `An email has been sent to the address of the account. 
    If you have not received a message, please check the spam folder.`,
    invalidToken: `Invalid reset token. Is is possible the token has 
    expired. Please try again and click the link within 10 minutes`,
    changePassword: {
      title: 'Reset Password',
      help: 'Reset your password. Use a strong password that you\'re not using elsewhere.',
    },
    newPassword: {
      title: 'New password',
      tooltip: 'Enter your new password. This needs to meet the complexity requirements measured by the bar under the input. It also cannot contain your username',
      help1: 'The new password must not contain your username',
      help2: 'Longer passwords are preferred with a mixture of uppercase and lowercase letters, digits and symbols',
      help3: 'Your password must be at least 6 characters long',
      placeholder: 'New Password',
      validationRequired: 'New password is required',
      validationLength: 'Password must be at least 6 characters long',
    },
    confirmPassword: {
      title: 'Confirm new password',
      tooltip: 'Enter your new password again to ensure you entered it correctly',
      placeholder: 'Confirm Password',
      validationRequired: 'Confirm password is required',
      validationMatch: 'Passwords do not match',
    },
    update: 'Change Password',
  },
  support: {
    title: 'Support',
    unsure: 'Unsure? We can help you:',
  },
  sideNav: {
    userManagement: 'User Management',
    chatSettings: 'Chat Settings',
    profile: 'Profile',
    logout: 'Log out',
  },
  resetPassword: {
    description: 'Change your password. Use a strong password that you\'re not using elsewhere.',
    newPassword: {
      label: 'New password',
      info: 'Enter your new password. This needs to meet the complexity requirements measured by the bar under the input. It also cannot contain your username',
      placeHolder: 'New Password',
      requiredValidation: 'New password is required',
      complexityValidation: 'Password is not strong enough',
      helpPoint1: 'The new password must not contain your username',
      helpPoint2: 'The password must meet certain complexity requirements. Longer passwords are preferred with a mixture of uppercase and lowercase letters, digits and symbols',
      helpPoint3: 'Your password is strong enough when the strength meter below has at least 3 bars filled',
    },
    confirmPassword: {
      label: 'Confirm new password',
      info: 'Enter your new password again to ensure you entered it correctly',
      placeHolder: 'Confirm Password',
      requiredValidation: 'Confirm password is required',
      matchValidation: 'Passwords do not match',
    },
    returnToLogin: 'Return to Login',
    updateButton: 'Reset Password',
    updateSuccessMessage: 'Password has been successfully reset, return to Login',
    updateErrorMessage: 'An error has occurred, please try again or contact Whizeo Support',
  },
  chatSettings: {
    tabs: {
      groups: 'Groups',
      tags: 'Tags',
      finalStatuses: 'Final Statuses',
      openingHours: 'Opening Hours/Dates',
    },
    groups: {
      headers: {
        name: 'Name',
        enabled: 'Enabled',
      },
      edit: 'Edit',
      create: 'Create a Chat Group',
      searchGroups: 'Search Groups',
      includeDisabled: 'Include disabled groups?',
      dialog: {
        createHeader: 'Create Chat Group',
        editHeader: 'Edit Chat Group',
        nameValidator: 'Please enter a name',
        save: 'Save',
      },
      error: {
        getGroups: 'Error getting chat groups',
        getGroup: 'Error getting group details',
        save: 'Error saving chat group',
      },
      success: {
        saveCreate: 'Chat group created',
        saveUpdate: 'Chat group updated',
      },
      warning: {
        nameExists: 'Chat group name already exists',
      },
    },
    tags: {
      headers: {
        name: 'Tag',
        enabled: 'Enabled',
      },
      edit: 'Edit',
      create: 'Create a Chat Tag',
      searchTags: 'Search Tags',
      includeDisabled: 'Include disabled tags?',
      dialog: {
        createHeader: 'Create Chat Tag',
        editHeader: 'Edit Chat Tag',
        nameValidator: 'Please enter a tag',
        save: 'Save',
      },
      error: {
        getTags: 'Error getting chat tags',
        getTag: 'Error getting tag details',
        save: 'Error saving chat tag',
      },
      success: {
        saveCreate: 'Chat tag created',
        saveUpdate: 'Chat tag updated',
      },
      warning: {
        nameExists: 'Chat tag already exists',
      },
    },
    statuses: {
      headers: {
        name: 'Name',
        enabled: 'Enabled',
        sendToOption: 'Send To Option',
        edit: 'Edit',
        delete: 'Delete',
      },
      edit: 'Edit',
      create: 'Create a Final Status',
      suggestions: 'View/Add suggested Final Statuses',
      searchStatuses: 'Search Statuses',
      includeDisabled: 'Include disabled statuses?',
      dialogStatus: {
        actions: 'Actions',
        createHeader: 'Create Chat Final Status',
        editHeader: 'Edit Chat Final Status',
        suggestionsHeader: 'View/Add Suggestions',
        nameValidator: 'Please enter a name',
        sendToOption: 'Include actions to send chats to another user?',
        save: 'Save',
        add: 'Add',
        delete: 'Delete',
      },
      dialogAction: {
        createHeader: 'Create Action',
        editHeader: 'Edit Action',
        nameValidator: 'Please enter a name',
        add: 'Add',
        edit: 'Edit',
        apply: 'Apply',
      },
      dialogConfirm: {
        header: 'Confirm Delete',
        yes: 'Yes',
        no: 'No',
        confirm: 'Are you sure you want to delete this final status?',
      },
      defaultStatuses: {
        requestSalesOutreach: 'Request Sales Outreach',
        leadCapturedForMarketing: 'Lead Captured for Marketing',
        requestsFurtherSupport: 'Requests Further Support',
        complaint: 'Complaint',
        spam: 'Spam',
      },
      defaultActions: {
        sendToOption: 'Include actions to send chats to another user',
        sendTo: 'Send to',
        none: 'None',
        block: 'Block',
      },
      warning: {
        nameExists: 'Final status name already exists',
      },
      success: {
        deleteStatus: 'Status deleted successfully',
        saveCreate: 'Status created successfully',
        saveUpdate: 'Status updated successfully',
      },
      error: {
        changeOrder: 'Error reordering statuses',
        deleteStatus: 'Error deleting status',
        saveStatus: 'Error saving status',
        addSuggestions: 'Error adding suggestions',
      },
    },
    openingHours: {
      messages: {
        title: 'Define your chat messages for out of hours requests and for days when the office is closed. These will only be displayed when the end-user chooses an option to talk to an agent.',
        outOfHoursMessage: 'Out of hours',
        closedMessage: 'Closed',
        outOfHoursMessageDefault: 'Sorry but our offices are currently closed',
        closedMessageDefault: 'Sorry buy our offices are closed today',
        save: 'Save',
        addField: 'Add Field',
        dialog: {
          header: 'Add message field',
          field: 'Field',
          format: 'Format',
          fields: {
            openingTime: 'Opening time',
            closingTime: 'Closing time',
          },
          timeFormats: {
            12: '12 hour clock (AM/PM)',
            24: '24 hours clock',
          },
          add: 'Add field',
        },
        error: {
          getMessages: 'Error getting messages',
        },
        success: {
          saveMessages: 'Messages saved successfully',
        },
      },
      openingHours: {
        title: 'Define your office opening hours when agents will be available to answer chats',
        days: {
          0: 'Sunday',
          1: 'Monday',
          2: 'Tuesday',
          3: 'Wednesday',
          4: 'Thursday',
          5: 'Friday',
          6: 'Saturday',
        },
        save: 'Save',
        error: {
          getOpeningHours: 'Error getting opening hours',
          saveOpeningHours: 'Error saving opening hours',
        },
        success: {
          saveOpeningHours: 'Opening hours saved successfully',
        },
      },
      closedDates: {
        title: 'Define any dates when your office will be closed and no agents will be available to answer chats.',
        add: 'Add',
        delete: 'Delete',
        headers: {
          closedDate: 'Closed Date',
          description: 'Description',
        },
        dialog: {
          header: 'Create closed date',
          closedDate: 'Closed date',
          description: 'Description',
          add: 'Add closed date',
        },
        error: {
          getClosedDates: 'Error getting closed dates',
          duplicate: 'This date already exists in the list',
          saveClosedDates: 'Error saving closed date',
          deleteClosedDate: 'Error deleting closed date',
        },
        success: {
          saveClosedDate: 'Closed date saved successfully',
          deleteClosedDate: 'Closed date deleted successfully',
        },
      },
    },
  },
};
